"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLimitedTags = void 0;
var _useSumLineWidth = require("./useSumLineWidth");
var _useTextWidth = require("./useTextWidth");
var CHIP_ADDITIONAL_WIDTH = 8 * 2 + 4 * 2;
var useLimitedTags = exports.useLimitedTags = function useLimitedTags(_ref) {
  var lineClamp = _ref.lineClamp;
  var getTextWidth = (0, _useTextWidth.useTextWidth)();
  var sumLineWidth = (0, _useSumLineWidth.useSumLineWidth)();
  return function (_ref2) {
    var _originalLines$lines, _originalLines$lines3;
    var data = _ref2.data,
      containerWidth = _ref2.containerWidth;
    var linearWidths = data.map(getTextWidth).map(function (width) {
      return width + CHIP_ADDITIONAL_WIDTH;
    });
    var originalLines = linearWidths.reduce(function (result, current) {
      var lineWidth = result.lineWidth + current;
      var currentLine = result.currentLine;
      var lines = result.lines;
      if (lineWidth > containerWidth) {
        lines.push([]);
        currentLine++;
        lineWidth = current;
      }
      lines[currentLine].push(current);
      return {
        currentLine: currentLine,
        lineWidth: lineWidth,
        lines: lines
      };
    }, {
      lineWidth: 0,
      currentLine: 0,
      lines: [[]]
    });
    var lineClampIndex = lineClamp - 1;
    var lastRowIndex = ((_originalLines$lines = originalLines.lines) === null || _originalLines$lines === void 0 ? void 0 : _originalLines$lines.length) - 1;
    if (lastRowIndex < lineClampIndex) {
      return data.length;
    }
    var visibleCount = 0;
    for (var i = 0; i < lineClampIndex; i++) {
      var _originalLines$lines2;
      visibleCount += ((_originalLines$lines2 = originalLines.lines) === null || _originalLines$lines2 === void 0 || (_originalLines$lines2 = _originalLines$lines2[i]) === null || _originalLines$lines2 === void 0 ? void 0 : _originalLines$lines2.length) || 0;
    }
    var lastRowVisibleCount = (((_originalLines$lines3 = originalLines.lines) === null || _originalLines$lines3 === void 0 ? void 0 : _originalLines$lines3[lineClampIndex]) || []).length;
    var andMoreTagsWidth = getTextWidth("...".concat(data.length - visibleCount - lastRowVisibleCount, " tags")) + CHIP_ADDITIONAL_WIDTH + 2;
    while (sumLineWidth((_originalLines$lines4 = originalLines.lines) === null || _originalLines$lines4 === void 0 ? void 0 : _originalLines$lines4[lineClampIndex], lastRowVisibleCount) + andMoreTagsWidth >= containerWidth) {
      var _originalLines$lines4;
      lastRowVisibleCount--;
      if (lastRowVisibleCount < 0) {
        lastRowVisibleCount = 0; //data.length;
        break;
      }
    }
    visibleCount += lastRowVisibleCount;
    return visibleCount;
  };
};